import { Directive, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';

@Directive({
  selector: '[appOnInit]',
  standalone: true,
})
export class OnInitDirective implements OnInit, OnDestroy {
  @Output() initialized = new EventEmitter<void>();
  @Output() destroyed = new EventEmitter<void>();

  ngOnInit(): void {
    this.initialized.next();
  }

  ngOnDestroy(): void {
    this.destroyed.next();
  }
}
